import { Injectable } from '@angular/core';

import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';

import { MAP_LAYER_Z_INDEXES } from '../../shared/constants';

@Injectable({
    providedIn: 'root'
})

export class MapClusterUtilityService {
    constructor(
    ) { }

    getMaxZoomForCurrentMapType(map: google.maps.Map): number {
        const mapTypeId = map.getMapTypeId();
        const mapType = map.mapTypes.get(mapTypeId);
        return mapType?.maxZoom ?? 22;
    }

    createMarkerCluster(map: google.maps.Map): MarkerClusterer {
        const markerCluster = new MarkerClusterer({
            map: map,
            markers: [],
            algorithm: new SuperClusterAlgorithm({ radius: 90, maxZoom: this.getMaxZoomForCurrentMapType(map) }),
            renderer: {
                render({ count, position }): google.maps.Marker {
                    const color = "#0000ff";
                    const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
                        <circle cx="120" cy="120" opacity=".6" r="70" />
                        <circle cx="120" cy="120" opacity=".3" r="90" />
                        <circle cx="120" cy="120" opacity=".2" r="110" />
                        <text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
                        </svg>`;
                    const parser = new DOMParser();
                    const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
                    svgEl.setAttribute("transform", "translate(0 25)");
                    const clusterOptions = {
                        position,
                        icon: {
                            url: `data:image/svg+xml;base64,${btoa(svg)}`,
                            anchor: new google.maps.Point(25, 25),
                        },
                        zIndex: MAP_LAYER_Z_INDEXES.Cluster
                    };
                    return new google.maps.Marker(clusterOptions);
                }
            },
        });
        return markerCluster;
    }
}
